import React from "react";
import "./trafficLightIndicator.css";

const TrafficLightIndicatorBurnoutExhaustion = ({ category, riskLevel, recommendation }) => {
  let textRisk = ""
  // Asignar color según el nivel de riesgo
  const getColor = (level) => {
    switch (level) {
      case 0:
        textRisk = "Agotamiento Bajo"
        return "green";
      case 1:
        textRisk = "Agotamiento Medio"
        return "yellow";
      case 2:
        textRisk = "Agotamiento Alto"
        return "red";
      default:
        return "gray";
    }
  };

  return (
    <div className="traffic-light-indicator">
      <h3 className="category-title">{category}</h3>
      <div className={`traffic-light ${getColor(riskLevel)}`}>
        {textRisk}
      </div>
      <p className="recommendation">{recommendation}</p>
    </div>
  );
};

export default TrafficLightIndicatorBurnoutExhaustion;
